<template>
    <div>
      <v-row align="center" class="pa-4 mb-2">
        <div class="test-activation-wrap" v-if="$checkPermission('test_activate_doorphone')">
          <BaseTextField
            v-model="apartmentNumber"
            type-input="number"
            icon="mdi-home"
            iconButton="mdi-account-clock-outline"
            :is-button="true"
            :button-color="'#4C6C93'"
            :button-disabled="!isApartmentValid"
            label="Номер квартиры"
            tooltip="Тестовая активация"
            :select-items="dayOptions"
            select-item-text="text"
            select-item-value="value"
            :select-value.sync="activationDays"
            :select-width="'120px'"
            :container-width="'420px'"
            :input-width="'180px'"
            @button-click="testActivate"
          />
        </div>
        <div v-else>
          <BaseTextField
            v-model="apartmentNumber"
            type-input="number"
            icon="mdi-magnify"
            :is-button="false"
            label="Номер квартиры"
          />
        </div>
        <div v-if="roleName !== 'master'">
          <BaseTextField
            v-model="telephoneSearch"
            :is-button="false"
            type-input="number"
            icon="mdi-magnify"
            label="Номер телефона"
            :maxlength="12"
          />
        </div>
        <div>
          <BaseTextField
            v-model="codeSearch"
            :is-button="false"
            icon="mdi-magnify"
            label="Код ключа"
          />
        </div>
        <v-spacer></v-spacer>
        <v-switch
          v-if="roleName === 'admin' && 'admin-engineer'"
          style="margin-right: 50px"
          class="mt-6"
          v-model="deletedAbonent"
          flat
          inset
          @click='showDeletedAbonents()'
          color="#85B285"
          label="Удаленные абоненты"
        >
        </v-switch>
        <v-tooltip bottom v-if="$checkPermission('web_edit_doorphone')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="border card-footer"
              v-bind="attrs"
              v-on="on"
              @click="openEditApartments"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Редактировать</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$checkPermission('export_csv_abonent_by_address')"
              color="#4C6C93"
              class="border card-footer"
              v-bind="attrs"
              v-on="on"
              @click="downloadReport"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
            </v-btn>
          </template>
          <span>Скачать отчёт о абонентах</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#4C6C93"
              class="border card-footer"
              v-bind="attrs"
              v-on="on"
              @click="updateListApartments"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>Обновить</span>
        </v-tooltip>
        <v-dialog
          v-model="dialog"
          persistent
          :retain-focus="false"
          max-width="500"
        >
          <v-card loading elevation="6" shaped>
            <v-card-title class="justify-center">Квартира № {{ apartmentNumber }}</v-card-title>
            <v-card-title>{{ displayTitle }}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="resetButton"
                color="primary darken-1"
                text
                @click.p.prevent="dropCall()"
              >
                Сбросить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
        <v-data-table
          class="table"
          :headers="displayTable"
          :items="filteredApartments"
          :items-per-page="20"
          :footer-props="{
              'items-per-page-options': [5, 10, 20, 50, 100],
              showFirstLastPage: true
          }"
        >
          <template v-slot:header.telephone>
            Телефон
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  style="cursor: default;"
                  class="btn__icon pa-0 ml-4"
                  width="18"
                  height="18"
                >
                  <v-icon size="x-large">mdi-chat-question-outline</v-icon>
                </v-btn>
              </template>
              <span>Номер телефона можно скопировать правой кнопкой мыши</span>
            </v-tooltip>
          </template>
          <template v-slot:item.key="{ item }">
            <div v-if="item.tenant" class="text-wrap-nowrap">
              <div v-for="tmp in item.tenant" :key="tmp.id">
                <li v-if="tmp.keys[0]">{{ tmp.keys[0].code }}</li>
              </div>
            </div>
          </template>
          <template v-slot:item.telephone="{ item }">
            <div v-if="item.tenant">
              <div v-for="tmp in item.tenant" :key="tmp.id">
                <div>
                  <v-btn
                    large
                    outlined
                    prepe
                    color="aliceblue"
                    style="height: 20px"
                    class="routerLink"
                    @click.prevent="handleClick(tmp.telephone, $event)"
                    @contextmenu.prevent="copyToClipboard(tmp.telephone)"
                  >
                    <li>{{ formatPhoneNumber(tmp.telephone) }}</li>
                  </v-btn>
                </div>
                <div
                  v-if="tmp.activation_expires_at"
                  class="temporary-note"
                  style="color: #0d6efd; margin-top: 4px;"
                >
                  Временный
                </div>
                <div
                  v-if="tmp.is_domyland"
                  class="domyland-note"
                  style="color: red; margin-top: 4px;"
                >
                  Клиент Домиленда
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <div v-if="item.tenant">
              <div v-for="tmp in item.tenant" :key="tmp.id">
                <!--v-if="roleName === 'admin' && 'admin-engineer'"-->
                <div v-if="roleName !== 'call-center'">
                  <v-tooltip v-if="$checkPermission('block_abonent') | $checkPermission('unlock_abonent')" bottom >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="$checkPermission('block_abonent') | $checkPermission('unlock_abonent')"
                        v-bind="attrs"
                        v-on="on"
                        color="primary darken-1"
                        text
                        @click="$set(dialogBlockAbonent, tmp.id, true)"
                        :aria-disabled="tmp.status === 'D'"
                      >
                        <v-icon x-small :color="(tmp.status === 'A') ? 'green' : (tmp.status === 'B') ? 'yellow' : 'red'" >
                          mdi-checkbox-blank-circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="tmp.status === 'A'">Активен</span>
                    <span v-if="tmp.status === 'B'">Заблокирован</span>
                    <span v-if="tmp.status === 'D'">Удален</span>
                  </v-tooltip>
                  <v-dialog
                    v-model="dialogBlockAbonent[tmp.id]"
                    persistent
                    :retain-focus="false"
                    max-width="480"
                    content-class="dialog-border-radius"
                    :key="tmp.id"
                  >
                    <v-card class="apartment-modal-card">
                      <v-card-title class="apartment-modal-title">
                        <v-icon left color="primary" class="mr-2">mdi-cellphone-check</v-icon>
                        <span v-if="tmp.status === 'A'">Заблокировать абонента?</span>
                        <span v-if="tmp.status === 'B'">Разблокировать абонента?</span>
                        <span v-if="tmp.status === 'D'">Абонент удален</span>
                      </v-card-title>
                      <v-card-text class="apartment-modal-text">
                        <div class="mb-2">Номер телефона: <strong>{{ tmp.telephone }}</strong></div>
                        <div v-if="tmp.keys[0]">Ключ: <strong>{{ tmp.keys[0].code }}</strong></div>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions class="apartment-modal-actions">
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          outlined
                          rounded
                          @click="$set(dialogBlockAbonent, tmp.id, false)"
                        >
                          Назад
                        </v-btn>
                        <v-btn
                          v-if="tmp.status === 'A'"
                          color="error"
                          rounded
                          @click.prevent="blockAbonent(tmp.id); $set(dialogBlockAbonent, tmp.id, false)"
                        >
                          Заблокировать
                        </v-btn>
                        <v-btn
                          v-if="tmp.status === 'B'"
                          color="success"
                          rounded
                          @click.prevent="unlockAbonent(tmp.id); $set(dialogBlockAbonent, tmp.id, false)"
                        >
                          Разблокировать
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                <div v-else>
                  <p v-if="tmp.status === 'A'" style="color: green;">Активен</p>
                  <p v-if="tmp.status === 'B'" style="color: chocolate;">Заблокирован</p>
                  <p v-if="tmp.status === 'D'" style="color: red;" >Удален</p>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item.PhonesActive="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  tile
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  style="cursor: default;"
                >
                  <v-icon :color="item.PhonesActive === 'on' ? 'green' : 'red'" x-small>mdi-checkbox-blank-circle</v-icon>
                </v-btn>
              </template>
              <span v-if="item.PhonesActive === 'on'">Включено</span>
              <span v-else>Выключено</span>
            </v-tooltip>
          </template>
          <template v-slot:item.IsActive="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  tile
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  style="cursor: default;"
                >
                  <v-icon :color="item.IsActive ? 'green' : 'red'" x-small>mdi-checkbox-blank-circle</v-icon>
                </v-btn>
              </template>
              <span v-if="item.IsActive">Включено</span>
              <span v-else>Выключено</span>
            </v-tooltip>
          </template>
          <template v-slot:item.forbid_car_number_activation="{ item }">
            <div v-if="item.tenant">
              <div v-for="tmp in item.tenant" :key="tmp.id">
                <div v-if="roleName !== 'call-center'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        tile
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="btn__icon pa-0"
                        width="18"
                        height="18"
                        style="cursor: default;"
                        @click="$set(dialogForbidCarNumber, tmp.id, true)"
                        :aria-disabled="tmp.status === 'D'"
                      >
                        <v-icon :color="tmp.forbid_car_number_activation ? 'red' : 'green'" x-small>mdi-checkbox-blank-circle</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="tmp.forbid_car_number_activation">Запрещена активация ГРЗ в моб. приложении</span>
                    <span v-else>Разрешена активация ГРЗ в моб. приложении</span>
                  </v-tooltip>
                  <v-dialog
                    v-model="dialogForbidCarNumber[tmp.id]"
                    persistent
                    :retain-focus="false"
                    max-width="530"
                    content-class="dialog-border-radius"
                    :key="'car-' + tmp.id"
                  >
                    <v-card class="apartment-modal-card">
                      <v-card-title class="apartment-modal-title">
                        <span class="apartment-modal-title-inner">
                          <v-icon :color="tmp.forbid_car_number_activation ? 'success' : 'orange'" class="apartment-modal-title-icon">mdi-car-cog</v-icon>
                          <span v-if="tmp.forbid_car_number_activation">Разрешить активацию ГРЗ в моб. приложении?</span>
                          <span v-else>Запретить активацию ГРЗ в моб. приложении?</span>
                        </span>
                      </v-card-title>
                      <v-card-text class="apartment-modal-text">
                        Номер телефона: <strong>{{ tmp.telephone }}</strong>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions class="apartment-modal-actions">
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          outlined
                          rounded
                          @click="$set(dialogForbidCarNumber, tmp.id, false)"
                        >
                          Назад
                        </v-btn>
                        <v-btn
                          v-if="tmp.forbid_car_number_activation"
                          color="success"
                          rounded
                          @click.prevent="allowCarNumberActivationAbonent(tmp.id); $set(dialogForbidCarNumber, tmp.id, false)"
                        >
                          Разрешить
                        </v-btn>
                        <v-btn
                          v-else
                          color="orange darken-2"
                          rounded
                          @click.prevent="forbidCarNumberActivationAbonent(tmp.id); $set(dialogForbidCarNumber, tmp.id, false)"
                        >
                          Запретить
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                <div v-else>
                  <span v-if="tmp.forbid_car_number_activation" style="color: orange;">Запрещено</span>
                  <span v-else style="color: green;">Разрешено</span>
                </div>
              </div>
            </div>
          </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { headersRulesRubetek3438, headersRulesRubetek3434, headersRulesBeward } from '../consts';
import BaseTextField from '../../../BaseTextField';
import formatPhoneNumberTextField from '@/mixins/formatPhoneNumberTextField';
import ruDateFormat from '@/mixins/ruDateFormat';

export default {
  name: 'ListApartments',
  components: { BaseTextField },
  mixins: [formatPhoneNumberTextField, ruDateFormat],
  props: ['id'],
  data () {
    return {
      updateInterval: null,
      apartmentID: null,
      deletedAbonent: false,
      lastCopiedText: null,
      updateResult: {},
      filters: {},
      combinedDataRules: [],
      abonents: [],
      rules: [],
      apartmentNumber: '',
      telephoneSearch: '',
      codeSearch: '',
      dialog: false,
      dialogForbidCarNumber: {},
      headersRulesRubetek3438,
      headersRulesRubetek3434,
      headersRulesBeward,
      filterAbonents: {},
      dialogBlockAbonent: {},
      dialogUnlockAbonent: {},
      includeAbonents: ['keys', 'user', 'agent.user'],
      activationDays: 1,
      dayOptions: [
        { text: '1 день', value: 1 },
        { text: '3 дня', value: 3 },
        { text: '7 дней', value: 7 },
      ],
    };
  },
  async created () {
    await this.getData();
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
      roleName: 'roleName',
    }),
    isApartmentValid () {
      const apt = String(this.apartmentNumber || '').trim();
      if (!apt) return false;
      return this.combinedDataRules.some(ap => String(ap.Number) === apt || String(ap.Prefix) === apt);
    },
    resetButton () {
      return this.updateResult.cWebCallStatus_Div !== '3';
    },
    displayTitle () {
      if (this.updateResult.cWebCallStatus_Div === '1') {
        return this.callDisconnect() || 'Звонок прерван.';
      }
      if (this.updateResult.cWebCallStatus_Div === '2') {
        return 'Идет звонок...';
      }
      if (this.updateResult.cWebCallStatus_Div === '3') {
        return 'Идет загрузка...';
      }
      if (!this.controlCall) {
        return 'Идет звонок...';
      }
      return 'Идет загрузка...';
    },
    controlCall (item) {
      return item.doorphone.device.model === 'RV-3438';
    },
    displayTable (item) {
      if (item.doorphone.device.model === 'RV-3438') {
        return this.headersRulesRubetek3438;
      }
      if (item.doorphone.device.model === 'RV-3434') {
        return this.headersRulesRubetek3434;
      } else {
        return this.headersRulesBeward;
      }
    },
    filteredApartments () {
      let apartments = this.combinedDataRules;

      if (this.codeSearch) {
        apartments = this.combinedDataRules.filter(apartment => {
          return apartment.tenant && apartment.tenant.some(tenant => {
            return tenant.keys?.[0]?.code?.toLowerCase().includes(this.codeSearch.toLowerCase());
          });
        });
      }
      if (this.telephoneSearch) {
        const phoneNumberToSend = this.telephoneSearch.replace(/\D/g, '');
        const searchLower = phoneNumberToSend.toLowerCase();
        apartments = this.combinedDataRules.filter(apartment => {
          return apartment.tenant && apartment.tenant.some(tenant => {
            const telephoneString = String(tenant.telephone);
            return telephoneString.toLowerCase().includes(searchLower);
          });
        });
      }
      if (this.apartmentNumber) {
        const apt = String(this.apartmentNumber).trim();
        apartments = apartments.filter(apartment => {
          return String(apartment.Number) === apt || String(apartment.Prefix) === apt;
        });
      }

      return apartments;
    },
  },
  methods: {
    ...mapActions({
      getCallStart: 'Doorphone/getCallStart',
      testActivateDoorphone: 'Doorphone/testActivateDoorphone',
      loadAbonents: 'Abonents/loadAbonents',
      exportCsvByAddress: 'Abonents/exportCsvByAddress',
      blockAccount: 'Abonents/blockAccount',
      unlockAccount: 'Abonents/unlockAccount',
      forbidCarNumberActivation: 'Abonents/forbidCarNumberActivation',
      allowCarNumberActivation: 'Abonents/allowCarNumberActivation',
      getCallEnd: 'Doorphone/getCallEnd',
      callCheck: 'Doorphone/callCheck',
      getRules: 'Doorphone/getRules',
      loadClients: 'Client/loadClients',
    }),
    async copyToClipboard (telephone) {
      if (this.lastCopiedText === telephone) {
        return;
      }
      try {
        await navigator.clipboard.writeText(telephone);
        this.lastCopiedText = telephone;
        this.$flash_success('Телефон скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать номер телефона');
      }
    },
    async getRedirectionClient (telephone, blank) {
      this.filters = {
        ...(telephone && { telephone_v2: telephone }),
      };
      let idClient = null;
      await this.loadClients({
        pagination: 1,
        limit: 1,
        page: 1,
        filters: this.filters,
      })
        .then((data) => {
          this.clients = data.data;
          idClient = this.clients[0].id;
          if (!this.clients[0]) {
            this.$flash_danger('Клиент не найден, проверьте номер телефона.');
          }
        })
        .catch(() => {
          this.$flash_warning('Ошибка при поиске клиента');
        });
      if (idClient) {
        const routeData = this.$router.resolve({ name: 'DetailClient', params: { id: idClient } });
        if (blank) {
          window.open(routeData.href, '_blank');
        } else {
          await this.$router.push({ name: 'DetailClient', params: { id: idClient } });
        }
      }
    },
    handleClick (telephone, event) {
      const isCtrlPressed = event.ctrlKey || event.metaKey; // event.metaKey для Mac (Cmd key)
      this.getRedirectionClient(telephone, isCtrlPressed);
    },
    formatPhoneNumber (phoneNumber) {
      phoneNumber = phoneNumber.toString();
      const digits = phoneNumber.replace(/\D/g, '');
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    },
    openEditApartments () {
      this.$router.push({ name: 'EditDoorphone', params: { id: this.$route.params.id, tabId: 1 } });
    },
    async updateListApartments () {
      await this.getData()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    async getData () {
      await this.getRules(this.$route.params.id)
        .then((data) => {
          this.rules = data.rules.data;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке квартир');
          }
        });
      if (this.roleName !== 'master') {
        this.filterAbonents.doorphone_id = this.$route.params.id;
        await this.loadAbonents({
          filters: this.filterAbonents,
          include: this.includeAbonents,
        })
          .then((data) => {
            this.abonents = data.abonents;
          })
          .catch((err) => {
            if (err.message.includes('422')) {
              const response = err.response.data;
              for (const input in response) {
                response[input].forEach(error => this.$flash_warning(input + ': ' + error));
              }
            } else {
              this.$flash_warning('Ошибка при загрузке абонентов');
            }
          });
      }
      this.combineApartmentsAndTenants();
    },
    downloadReport () {
      this.exportCsvByAddress(this.$route.params.id)
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response], {
            type: 'application/csv',
          }));
          const link = document.createElement('a');
          link.href = url;
          link.download = `abonents_doorphone_${this.$route.params.id}.csv`;
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании полного отчёта');
        });
    },
    getAbonents () {
      this.filterAbonents.doorphone_id = this.$route.params.id;
      this.loadAbonents({
        filters: this.filterAbonents,
        include: this.includeAbonents,
      })
        .then(() => {
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке абонентов');
          }
        });
      this.combineApartmentsAndTenants();
    },
    combineApartmentsAndTenants () {
      const apartmentTenants = {};
      this.abonents.forEach(tenant => {
        if (!apartmentTenants[tenant.apartment]) {
          apartmentTenants[tenant.apartment] = [];
        }
        apartmentTenants[tenant.apartment].push(tenant);
      });

      this.combinedDataRules = this.rules.map(apartment => {
        if (['Beward', 'ISCom'].includes(this.doorphone.device.manufacturer)) {
          this.apartmentID = apartment.Number;
        } else {
          this.apartmentID = Number(apartment.Prefix);
        }
        const apartmentTenantData = apartmentTenants[this.apartmentID] || [];
        return {
          ID: apartment.ID,
          Prefix: apartment.Prefix,
          Number: apartment.Number,
          Comment: apartment.Comment,
          Login: apartment.Login,
          IsActive: apartment.IsActive,
          Replace: apartment.Replace,
          Replace5: apartment.Replace5,
          Phone1: apartment.Phone1,
          Phone2: apartment.Phone2,
          PhonesActive: apartment.PhonesActive,
          tenant: apartmentTenantData,
        };
      });
    },
    showDeletedAbonents () {
      if (this.deletedAbonent) {
        this.filterAbonents.status = 'ABD';
      } else {
        this.filterAbonents.status = 'AB';
      }
      this.getData();
    },
    blockAbonent (idAbonent) {
      this.blockAccount(idAbonent)
        .then(() => {
          this.getData();
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка блокировки аккаунта');
        });
    },
    unlockAbonent (idAbonent) {
      this.unlockAccount(idAbonent)
        .then(() => {
          this.getData();
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка разблокировки аккаунта');
        });
    },
    forbidCarNumberActivationAbonent (idAbonent) {
      this.forbidCarNumberActivation(idAbonent)
        .then(() => {
          this.getData();
          this.$flash_success('Активация ГРЗ в моб. приложении запрещена');
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при запрете активации ГРЗ');
        });
    },
    allowCarNumberActivationAbonent (idAbonent) {
      this.allowCarNumberActivation(idAbonent)
        .then(() => {
          this.getData();
          this.$flash_success('Активация ГРЗ в моб. приложении разрешена');
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при разрешении активации ГРЗ');
        });
    },
    testActivate () {
      const apt = Number(this.apartmentNumber);
      if (!apt || apt <= 0) {
        this.$flash_danger('Укажите номер квартиры');
        return;
      }
      if (![1, 3, 7].includes(Number(this.activationDays))) {
        this.$flash_danger('Выберите длительность 1, 3 или 7 дней');
        return;
      }
      const form = {
        apartment: apt,
        activation_duration_days: Number(this.activationDays),
      };
      this.testActivateDoorphone({
        doorphoneId: this.$route.params.id,
        form,
      })
        .then(() => {
          this.$flash_success('Тестовая активация создана');
          this.updateListApartments();
        })
        .catch((err) => {
          if (err.response) {
            const status = err.response.status;

            if (status === 422 && err.response.data) {
              const response = err.response.data;
              for (const field in response) {
                if (Array.isArray(response[field])) {
                  response[field].forEach(error => {
                    this.$flash_warning(`${field}: ${error}`);
                  });
                }
              }
              return;
            }
            if (err.response.data && err.response.data.error) {
              this.$flash_warning(err.response.data.error);
              return;
            }
            this.$flash_warning(`Ошибка ${status}: ${err.response.statusText}`);
          } else {
            this.$flash_danger('Не удалось выполнить тестовую активацию');
          }
        });
    },
    dropCall () {
      this.getCallEnd({
        doorphoneId: this.$route.params.id,
      })
        .then(() => {
          this.dialog = false;
          clearInterval(this.updateInterval);
          this.$flash_success('Звонок завершен');
        })
        .catch(() => {
          clearInterval(this.updateInterval);
          this.$flash_warning('Не удалось завершить звонок');
        });
    },
    callDisconnect () {
      this.updateResult.cWebCallStatus_Div = '3';
      clearInterval(this.updateInterval);
      setTimeout(() => this.dropCall(), 3000);
    },
  },
};
</script>

<style>
.test-activation-wrap {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .test-activation-wrap {
    gap: 6px;
    overflow-x: auto;
    white-space: nowrap;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 5px !important;
  font-size: 13px !important;
  max-width: 2%;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.border {
  border-radius: 16px;
}
.card-footer {
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  background: none;
  border: none;
  color: blue;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}

.v-application a {
  color: #434850;
}
.v-application p {
  margin-bottom: 0;
}

.v-text-field-like {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 6px;
  margin-bottom: 0;
  height: 40px;
}

.v-icon-before {
  margin-right: 8px;
}

.text-wrap-nowrap {
  white-space: nowrap;
}

.custom-input {
  width: 350px;
  border: none;
  outline: none;
}
@media screen and (max-width: 600px) {
  .v-text-field-like {
    width: 200px;
  }
}

.apartment-modal-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.apartment-modal-title {
  font-size: 1.1rem;
  font-weight: 600;
  padding: 20px 24px 12px;
}
.apartment-modal-title-inner {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.apartment-modal-title-icon {
  flex-shrink: 0;
  vertical-align: middle;
}
.apartment-modal-text {
  padding: 12px 24px 16px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.95rem;
}
.apartment-modal-actions {
  padding: 12px 24px 20px;
  gap: 8px;
}
.apartment-modal-actions .v-btn {
  text-transform: none;
  font-weight: 500;
}
</style>
